<template lang="html">
  <div id="coverage-page">
    <div class="container main-container">
      <h1 class="page-title" data-aos="fade-in" data-aos-duration="1000">Cobetura</h1>

      <div class="box-map" data-aos="fade-in" data-aos-duration="1000">
        <img src="public/images/pages/coverage/map.svg">
      </div>

      <div class="box-info">
        <div class="col-md-6 col-lg-4 col-list" data-aos="fade-in" data-aos-duration="400">
          <ul class="map-list">
            <li>
              <h5>AVIP Terminal Portales</h5>
              <p>
                Av. de las Torres 1234, Centra Camionera<br />
                C.P. 45580, Tlaquepaque, Jalisco.
              </p>
              <p class="mt-2">
                Tel: 33 1122 3344
              </p>
            </li>
          </ul>
        </div>

        <div class="col-md-6 col-lg-4 col-list" data-aos="fade-in" data-aos-duration="850">
          <ul class="map-list">
            <li>
              <h5>AVIP Terminal Zapopan</h5>
              <p>
                Av. Guadalupe 1234, Chapalita Inn<br />
                C.P. 45037, Zapopan, Jalisco.
              </p>
              <p class="mt-2">
                Tel: 33 1122 3344
              </p>
            </li>
          </ul>
        </div>

        <div class="col-md-6 col-lg-4 col-list" data-aos="fade-in" data-aos-duration="1250">
          <ul class="map-list">
            <li>
              <h5>AVIP Terminal Mazatlán</h5>
              <p>
                Río Pánuco & José Angel, Palos Prietos,<br />
                C.P. 82010 Mazatlán, Sinaloa.
              </p>
              <p class="mt-2">
                Tel: 33 1122 3344
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
